import axios from 'axios';

// En dev sur la même machine : window.location.hostname = "localhost" -> localhost:8000.
// Ouvert depuis une autre machine (ex: le widget lancé sur le PC du
// partenaire) : window.location.hostname = l'IP réseau de la machine JUMS
// -> on tape le port 8000 de CETTE machine, jamais "localhost" (qui
// désignerait sinon la machine du partenaire lui-même). Surchargeable via
// REACT_APP_API_URL pour un déploiement où front et back JUMS ne sont pas
// sur le même hôte.
const API_URL = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:8000`;

const api = axios.create({
  baseURL: API_URL,
});

// Ajoute automatiquement le token JWT à chaque requête
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Si le token expire → redirige vers le login
// MAIS pas pour la route /auth/login elle-même
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRoute = error.config?.url?.includes('/auth/login');
    if (error.response?.status === 401 && !isLoginRoute) {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;
export { API_URL };